<div class="table-controls row">
  <div class="table-filters">
    <div class="col-lg-12 text-right">

      <ng-container *ngIf="tableViews | async as tableViews">

        <ng-container *ngIf="tableViews.length > 1">

          <div class="views">
            <ul class="nav nav-pills ml-0 mb-0 pull-left">

              <li *ngFor="let tableView of tableViews"
                  [class]="tableView.class"
                  [hidden]="tableView.hidden"
                  [ngClass]="{
                    'active': tableView.active,
                    'hidden': tableView.hidden,
                    'disabled': (disabled | async)
                  }">

                <a *ngIf="tableView.route"
                   data-toggle="pill"
                   [routerLink]="disabled.value ? null : tableView.route">
                  {{ tableView.label }}
                </a>

                <a *ngIf="!tableView.route"
                   data-toggle="pill"
                   (click)="activateTableView(tableView)">
                  {{ tableView.label }}
                </a>

              </li>

            </ul>
          </div>

        </ng-container>

        <ng-container *ngFor="let tableView of tableViews">

          <div class="menus"
               [class]="tableView.class"
               [hidden]="!tableView.active || tableView.hidden">

            <ng-container *ngFor="let menu of tableView.menus">

              <span class="menu mr-sm"
                    [class]="menu.class"
                    [hidden]="menu.hidden">

                <label>{{ menu.label }}</label>

                <select [ngClass]="{ 'disabled': (disabled | async) }"
                        [disabled]="(disabled | async)"
                        [ngModel]="getOrCreateModel(menu)"
                        (ngModelChange)="selectOption(tableView, menu, $event)">

                  <option *ngFor="let option of menu.options"
                          [class]="option.class"
                          [hidden]="option.hidden"
                          [ngClass]="{ 'selected': option.selected }"
                          [ngValue]="option"
                          [selected]="option.selected">
                    {{ option.label }}
                  </option>

                </select>

              </span>

            </ng-container>

            <span class="modes">

              <a *ngFor="let mode of tableView.modes"
                 [class]="mode.class"
                 [hidden]="mode.hidden"
                 [ngClass]="{
                   'active': mode.active,
                   'disabled': (disabled | async)
                 }"
                 [title]="mode.title"
                 (click)="activateMode(tableView, mode)">
                <i *ngIf="mode.iconClass" [class]="mode.iconClass"></i>
                {{ mode.label }}
              </a>

            </span>

          </div>

        </ng-container>

      </ng-container>

    </div>
  </div>
</div>
